
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/desarrollos/thankyoupage-contacto-gracias",
      function () {
        return require("private-next-pages/desarrollos/thankyoupage-contacto-gracias.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/desarrollos/thankyoupage-contacto-gracias"])
      });
    }
  